import React from 'react';
import { OfferBase } from "./offer-base";
export class WelcomeOffer extends OfferBase {
    id = "welcomeBonus";
    analyticsCategory = "Conversion";

    shouldBeVisible(): boolean {
        const cStatus = this.services.cmsSegmentation.isCstatus;
        return !cStatus && super.shouldBeVisible();
    }
    
    shoulUseLinkToOfferAnimation(): boolean {
        return true;
    }

    render(): React.ReactNode {
        let IconComponent = this.services.theme.currentTheme.icons.linkToOfferIcon;
        return (
            <IconComponent size={4} sizeIsHeight />
        );
    }
}
